var Writaholics = Writaholics || {};

Writaholics.ContactForm = function () {

	var _difficultyLevelInput = 'select[name="data[Submission][difficulty_level]"]';
	var durationInput = 'select[name="data[Submission][duration]"]';
	var wordsRangeInput = '.words-range';
	var price = '.price';
	var _totalWords = '.total-words';
	var _submittingPrice = '#SubmissionPrice';
	var _durationLbl = $(_difficultyLevelInput).data('duration-lbl');

	var _handleDifficultyLevelOnChange = function() {
		var cachedDifficultyLevel = $(this);
		var selectedValue = cachedDifficultyLevel.val();
		_resetFields();
		if (selectedValue == '') {
			$(durationInput).prop("disabled", "disabled");
			_disabledWordsRangeInput();
		}
		$(durationInput).empty();
		var difficultyLevelId = cachedDifficultyLevel.find(':selected').data('difficulty-level-id');
		let entries = Object.entries(difficultyLevel);
		for (const [prop, val] of entries) {
			if (prop == difficultyLevelId) {
				$(durationInput).append("<option value='*'>" + _durationLbl +"</option>");
				let value = Object.entries(val);
				for (const [prop, vals] of value) {
					$(durationInput).append("<option price='" + vals.price + "' value='" + vals.name + "'>" + vals.name + "</option>");
				}
			}
		}
		$(durationInput).prop("disabled", false);
		_handleDurationOnChange();
	}

	var _handleDurationOnChange =  function() {
		$(durationInput).on('change', function () {
			var cachedDuration = $(this);
			var selectedValue = cachedDuration.val();
			if (selectedValue == '*') {
				_disabledWordsRangeInput();
			}	else {
				_enabledWordsRangeInput();
			}
			_resetFields();
			var currentPrice = cachedDuration.find(':selected').attr('price');
			$(_submittingPrice).val(currentPrice);
			_handleWordsRangeOnChange(currentPrice);

		});
	}

	// handle when words range is changed
	var _handleWordsRangeOnChange = function (latestPrice) {
		_resetFields();
		// show the price of selected duration
		$(price).html(latestPrice);
		// on change event on words range input
		$(wordsRangeInput).on('change', function () {
			// cache the reference
			var cachedWords = $(this);
			var defaultWordRange = cachedWords.attr('data-default-value');
			// parse string into integer
			var wordRange = parseInt(cachedWords.val());
			// show the range value in html
			$(_totalWords).html(wordRange);
			// calculate the final price
			var finalPrice = parseFloat(latestPrice) * (wordRange / parseInt(defaultWordRange))
			// show the final price
			$(price).html(finalPrice);
			$(_submittingPrice).val(finalPrice);
		});
	}

	// reset the fields and set default value
	var _resetFields = function () {
		var defaultWordRange = $(wordsRangeInput).attr('data-default-value');
		$(wordsRangeInput).val(defaultWordRange);
		$(_totalWords).html(defaultWordRange);
		_emptyPriceHtml();
	}

	// empty price in html
	var _emptyPriceHtml = function () {
		$(price).html('0');
	}

	// disable words range input
	var _disabledWordsRangeInput = function () {
		$(wordsRangeInput).attr("disabled", "disabled");
	}

	// enable words range input
	var _enabledWordsRangeInput = function () {
		$(wordsRangeInput).prop("disabled", false);
	}

	var _init = function () {
		$(_difficultyLevelInput).on('change', _handleDifficultyLevelOnChange);
	}

	/** PUBLIC API **/
	return {
		init: function () { return _init(); }
	};

}();

jQuery(function () {
	Writaholics.ContactForm.init();
	jQuery.subscribe('Viktory.Webforms.Submit.fail', Writaholics.ContactForm.init);
});
